import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./pages/home-page";
import AboutUs from "./pages/about-us";
import RotoinfissiPoles from "./pages/rotoinfissi-poles";
import Consultancy from "./pages/consultancy";
import Contacts from "./pages/contacts";
import NotFound from "./pages/not-found";
import PrivacyPolicy from "./pages/privacy-policy";
import CookiePolicy from "./pages/cookie-policy";
import TermsAndConditions from "./pages/termsAndConditions";

import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import { PATH, SECTIONS_ID } from "./constants/navigation";
import Wrapper from "./router/Wrapper";
import CookieBanner from "./components/cookie-banner/cookie-banner";
import {
  aboutDevelopment,
  aboutInnovation,
  aboutStart,
  consultancyHero,
  coverIntro,
  poles,
  tip,
  whyUs,
} from "./assets/images";
import usePreloadImages from "./hooks/usePreloadImages";

function AppContent() {
  const location = useLocation();
  const isFullScreenPage = location.pathname === PATH.notFound;

  usePreloadImages([
    aboutDevelopment,
    aboutInnovation,
    aboutStart,
    consultancyHero,
    coverIntro,
    poles,
    tip,
    whyUs,
  ]);

  return (
    <Wrapper>
      <a href={`#${SECTIONS_ID.app}`} className="skip-link">
        Salta al contenuto
      </a>
      <div id="app-root" className="app__container">
        {!isFullScreenPage && (
          <header className="app__header">
            <Header />
          </header>
        )}
        <CookieBanner />

        <main className="app__content" id={SECTIONS_ID.app}>
          <Routes>
            {/* MAIN ROUTES */}
            <Route path={PATH.home} element={<Home />} />
            <Route path={PATH.about} element={<AboutUs />} />
            <Route path={PATH.poles} element={<RotoinfissiPoles />} />
            <Route path={PATH.consultancy} element={<Consultancy />} />
            <Route path={PATH.contacts} element={<Contacts />} />
            {/* PRIVACY, TERMS & COOKIE */}
            <Route path={PATH.privacy} element={<PrivacyPolicy />} />
            <Route path={PATH.cookie} element={<CookiePolicy />} />
            <Route path={PATH.terms} element={<TermsAndConditions />} />
            {/* NOT FOUND*/}
            <Route path={PATH.notFound} element={<NotFound />} />
            <Route
              path={PATH.unknown}
              element={<Navigate to={PATH.notFound} replace />}
            />
          </Routes>
        </main>

        {!isFullScreenPage && (
          <footer className="app__footer">
            <Footer />
          </footer>
        )}
      </div>
    </Wrapper>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}
